type SystemNotificationKind = 'turn' | 'chat';

interface SystemNotificationOptions {
  kind: SystemNotificationKind;
  title: string;
  body: string;
  url: string;
  tag: string;
}

export const canUseSystemNotifications = () => (
  typeof window !== 'undefined' &&
  'Notification' in window &&
  'serviceWorker' in navigator
);

export const getSystemNotificationPermission = (): NotificationPermission | 'unsupported' => {
  if (!canUseSystemNotifications()) return 'unsupported';
  return Notification.permission;
};

export const requestSystemNotificationPermission = async () => {
  if (!canUseSystemNotifications()) return 'unsupported' as const;
  return Notification.requestPermission();
};

export const showSystemNotification = async ({
  kind,
  title,
  body,
  url,
  tag,
}: SystemNotificationOptions) => {
  if (!canUseSystemNotifications() || Notification.permission !== 'granted') return false;

  const registration = await navigator.serviceWorker.ready;
  await registration.showNotification(title, {
    body,
    tag,
    badge: '/icons/icon-192.png',
    icon: '/icons/icon-192.png',
    data: { url, kind },
  } as NotificationOptions);

  return true;
};
